module.exports = {
	"articleTitle1": "Rackham conference showcases discoveries and innovations in ...",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Rackham Graduate School",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/article/rackham-secondary",
	"articleSnippet1": "Jun 14, 2017 ... The third Multidisciplinary Conference on Reinforcement Learning and Decision \nMaking took place at the Rackham Graduate School between ...",
	"articleSnippet2": "Jan 27, 2014 ... The Rackham Graduate School hardly resembles the likes of the Michigan \nLeague or North Quad. It sticks out, yet it's still an afterthought.",
	"totalMisc": 0,
	"articleTitle2": "Rethinking Rackham",
	"address": "915 E Washington St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170119/agc.NEW_.ClaudiaRankine.1.16.17.004.jpg?itok=hvMNG0Du",
			"author": "Amelia Cacchione",
			"caption": "Poet and MacArthur Fellow Claudia Rankine talks about racism and her poem, Citizen, at Rackham Auditorium on Monday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161208/agc.FEA_.FriarsConcert.12.2.16.0182.jpg?itok=rudIxzvw",
			"author": "Amelia Cacchione",
			"caption": "LSA junior Fisher Died and School of Music, Theatre & Dance junior Wesley Fields perform with The Friars at their 61st Annual Study Break Concert at Rackham Auditorium on Friday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160310/KMJ_5208.jpg?itok=r9bpyr0_",
			"author": "Sinduja Kilaru",
			"caption": "LSA junior Emily Liu recreates Relationship Remix for participants during the Depression on College Campuses Conference in Rackham on Wednesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160327/laa.FEA_.ImprovFest.3.26.16.4_0.jpg?itok=2ULpoSpp",
			"author": "Luna Anna Archey",
			"caption": "Members of George Washington University's receSs perform a skit about Jersey Jesus at the 1st Annual University of Michigan Improv Festival at Rackham Auditorium on Saturday."
		}
	],
	"position": {
		"lat": 42.2808,
		"lng": -83.7383
	},
	"tips": [
		{
			"text": "I really enjoy studying here since it's pretty quiet and has lots of natural light.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 5,
			"bathroom": "Lobby"
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/rackham.json
// module id = 955
// module chunks = 0